import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';

import { getJwtToken, getJwtPayload, getIsMember } from 'models/login';
import { getGrModal } from 'models/events';

import MemberRoute from './Member';
import BlogsRoute from './Blogs';
import Event from './Event';
import EventInfo from './EventInfo';
import Contract from './Contract';
import Records from './Records';
import Record from './Record';
import Payment from './Payment';
import Result from './Result';
import Questions from './Questions';

const childrenHomeRoute: CustomRoute = {
	path: '',
	components: () => [import(/* webpackChunkName: 'home' */ './Home')],
	render: ([Home]) => <Home />,
	onEnter: async ({ store, next }) => {
		console.log('on Enter Home');

		const localStorageToken = localStorage.getItem('token');
		if (localStorageToken) {
			await store.dispatch(getJwtToken(localStorageToken)); // 將 JWT token 存入 store
			await store.dispatch(getJwtPayload(localStorageToken)); // 解析並將 JWT payload 存入 store
			await store.dispatch(getGrModal());
		}

		const children = await next();
		console.log('on Enter Home / end');
		return children;
	},
};

const routes: CustomRoute = {
	path: '/',
	components: () => [],
	render: (_, children) => children,
	onEnter: async ({ store, next }) => {
		console.log('on Enter Root');

		const localStorageToken = localStorage.getItem('token');
		if (localStorageToken) {
			await store.dispatch(getJwtToken(localStorageToken)); // 將 JWT token 存入 store
			await store.dispatch(getJwtPayload(localStorageToken)); // 解析並將 JWT payload 存入 store
			await store.dispatch(getIsMember()); // 確認目前 token 是否GR會員
		}

		const children = await next();
		console.log('on Enter Root / end');

		return children;
	},
	children: [
		childrenHomeRoute,
		MemberRoute,
		BlogsRoute,
		Event,
		EventInfo,
		Contract,
		Records,
		Record,
		Payment,
		Result,
		Questions,
	],
};

export default routes;
